import React from 'react'
import Aboutcomponent from '../components/About/About'

const About = () => {
  return <Aboutcomponent />
}

export default About
